<template>
  <div class="widget-form" :style="forDevOnly">
    <BuySellToggle v-if="buyAndSellAreEnabled" />
    <Transition name="fade" mode="out-in">
      <component :key="orderStore.form.mode" :is="currentForm"></component>
    </Transition>
  </div>
</template>
<script setup>
import { shallowRef, computed, onMounted, watch } from "vue";
import { useTitle } from "@vueuse/core";

import { onBeforeRouteLeave } from "vue-router";
import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import useThirdPartyScripts from "@/composables/api/useThirdPartyScripts";
import useMerchantSettings from "@/composables/ui/useMerchantSettings";

import BuySellToggle from "@/components/ui/toggles/BuySellToggle.vue";
import WidgetBuyForm from "@/components/forms/Widget/WidgetBuyForm.vue";
import WidgetSellForm from "@/components/forms/Widget/WidgetSellForm.vue";

const currentForm = shallowRef(null);
const globalStore = useGlobalStore();
const orderStore = useOrderFormStore();
const { useSiftScript } = useThirdPartyScripts();
const { getMerchantSettings } = useMerchantSettings();

// to dev against dark bg as prod
const devUrls = ["localhost", "staging", "sandbox", "dev", "d1", "s1"];
const checkDevUrl = (url) => {
  return devUrls.filter((host) => url.indexOf(host) >= 0);
};

const forDevOnly = computed(() => {
  const isDev = checkDevUrl(window.location.hostname).length > 0;
  return isDev ? { background: "#111630" } : "";
});
const isBuy = computed(() => orderStore.isBuyMode);
const title = computed(() => {
  return isBuy.value ? "Banxa – Buy Crypto" : "Banxa – Sell Crypto";
});
const buyAndSellAreEnabled = computed(
  () =>
    globalStore.getPayments?.length > 0 && globalStore.getPayouts?.length > 0
);

onBeforeRouteLeave((to, from, next) => {
  window.top.location =
    window.location.href
      .replace("widget", "")
      .replace("?code=x2qYcnqYeXoZ6hQLPor", "") + to.href;
  next();
});

watch(
  () => isBuy.value,
  (mode) => {
    if (mode) currentForm.value = WidgetBuyForm;
    else currentForm.value = WidgetSellForm;
  },
  { immediate: true }
);

onMounted(async () => {
  await useSiftScript();
  await getMerchantSettings();
  globalStore.setTheme("DARK");
});

watch(
  () => title.value,
  () => {
    useTitle(title.value);
  }
);
</script>

<style lang="scss" scoped>
.widget-form {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: start;
  height: 100%;

  @include breakpoint($min-m) {
    padding: 3rem 10rem 0;
  }
}

:deep(.form) {
  padding-bottom: 0;
}
</style>
